






































































import { ref, defineComponent, PropType, watch, onMounted } from "@nuxtjs/composition-api";
import {
  setSizeProductDetail,
  setSizeProductList,
  setSizeSwatch,
} from "~/modules/catalog/category/helpers";
import { Navigation, Pagination, Thumbs, Scrollbar } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation, Pagination, Thumbs, Scrollbar]);

export default defineComponent({
  name: "ProductGallery",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    productImages: {
      type: Array as PropType<Array<{ url: string; label?: string }>>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const thumbsSwiper = ref(null);
    const mainSwiper = ref(null);
    const zoomContainers = ref([]);
    const isZoomed = ref(false);
    const isTouchDevice = ref(false);
    const touchStartTime = ref(0);
    const touchStartX = ref(0);
    const touchStartY = ref(0);

    // Placeholder image là ảnh mặc định khi ảnh không load được
    const placeholderImage = "~assets/images/products-viewed-empty.webp";

    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    };

    const setMainSwiper = (swiperInstance) => {
      mainSwiper.value = swiperInstance;
    };

    const handleImageError = (event) => {
      event.target.src = placeholderImage;
      emit("image-error", event);
    };

    const handleMouseMove = (event) => {
      if (isTouchDevice.value) return;
      
      const container = event.currentTarget;
      const img = container.querySelector('.zoom-image');
      
      // Calculate position
      const { left, top, width, height } = container.getBoundingClientRect();
      const x = (event.clientX - left) / width * 100;
      const y = (event.clientY - top) / height * 100;
      
      // Apply zoom effect
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(2.5)';
      isZoomed.value = true;
    };

    const handleMouseLeave = (event) => {
      if (isTouchDevice.value) return;
      
      const img = event.currentTarget.querySelector('.zoom-image');
      img.style.transform = 'scale(1)';
      isZoomed.value = false;
    };
    
    const handleTouchStart = (event) => {
      touchStartTime.value = Date.now();
      touchStartX.value = event.touches[0].clientX;
      touchStartY.value = event.touches[0].clientY;
    };
    
    const handleTouchMove = (event) => {
      // If already zoomed, allow panning
      if (isZoomed.value) {
        const container = event.currentTarget;
        const img = container.querySelector('.zoom-image');
        const { left, top, width, height } = container.getBoundingClientRect();
        const x = (event.touches[0].clientX - left) / width * 100;
        const y = (event.touches[0].clientY - top) / height * 100;
        
        img.style.transformOrigin = `${x}% ${y}%`;
        event.preventDefault(); // Prevent page scrolling when zoomed
      }
    };
    
    const handleTouchEnd = (event) => {
      const touchDuration = Date.now() - touchStartTime.value;
      const touchMoveX = Math.abs(event.changedTouches[0].clientX - touchStartX.value);
      const touchMoveY = Math.abs(event.changedTouches[0].clientY - touchStartY.value);
      
      // If it was a tap (short duration, minimal movement)
      if (touchDuration < 300 && touchMoveX < 10 && touchMoveY < 10) {
        const container = event.currentTarget;
        const img = container.querySelector('.zoom-image');
        
        if (isZoomed.value) {
          // Reset zoom
          img.style.transform = 'scale(1)';
          isZoomed.value = false;
        } else {
          // Apply zoom at touch point
          const { left, top, width, height } = container.getBoundingClientRect();
          const x = (event.changedTouches[0].clientX - left) / width * 100;
          const y = (event.changedTouches[0].clientY - top) / height * 100;
          
          img.style.transformOrigin = `${x}% ${y}%`;
          img.style.transform = 'scale(2.5)';
          isZoomed.value = true;
        }
      }
    };
    
    const resetZoom = (event) => {
      event.stopPropagation();
      const container = event.currentTarget.closest('.hover-zoom-container');
      const img = container.querySelector('.zoom-image');
      img.style.transform = 'scale(1)';
      isZoomed.value = false;
    };
    
    onMounted(() => {
      // Check if we're on a touch device
      isTouchDevice.value = 'ontouchstart' in window || 
        navigator.maxTouchPoints > 0;
    });

    watch(
      () => props.productImages,
      (newImages) => {
        if (thumbsSwiper.value) {
          thumbsSwiper.value.slideTo(0);
        }
        if (mainSwiper.value) {
          mainSwiper.value.update();
          mainSwiper.value.slideTo(0);
        }
        setTimeout(() => {
          if (thumbsSwiper.value) {
            thumbsSwiper.value.update();
          }
          if (mainSwiper.value) {
            mainSwiper.value.update();
            mainSwiper.value.slideTo(0);
          }
        }, 100);
      },
      { deep: true }
    );

    return {
      thumbsSwiper,
      setThumbsSwiper,
      modules: [Navigation, Thumbs, Scrollbar],
      handleImageError,
      setSizeProductDetail,
      setSizeProductList,
      setSizeSwatch,
      mainSwiper,
      setMainSwiper,
      handleMouseMove,
      handleMouseLeave,
      handleTouchStart,
      handleTouchMove,
      handleTouchEnd,
      resetZoom,
      isZoomed,
      isTouchDevice,
      zoomContainers
    };
  },
});
